import "./iot1.css";

import React from "react";
import ScrollHooks from "../ScrollHooks.js";
import AjaxHooks from "../AjaxHooks";
// import LineChart from "../LineChart";

const Iot1 = () => {
  return (
    <div>
      "texto de prueba" "texto de prueba"
      <ScrollHooks />
      <ul className="iotGrid-container">
        <AjaxHooks />
        <li key={Date.now()+Math.random().toString(16).substr(2, 8)} className="iotGrid-item">
          <div className="row">
            <div className="col-1">Sensor: 2</div>
            <div className="col-2">Texto 3</div>
          </div>
          <div className="row">
            <div className="col-1">Ruido: 20</div>
            <div className="col-2">Temper: 30</div>
          </div>
          <div className="row">
            <div className="col-1">Luz: 200</div>
            <div className="col-2">Texto 300</div>
          </div>
          <div className="row">
            <div className="col-1">Power: 2000</div>
            <div className="col-2">?????: 3000</div>
          </div>
        </li>
        <li key={Date.now()+Math.random().toString(16).substr(2, 8)} className="iotGrid-item">
          <div>
            <div className="row">
              <div className="col-1">texto 2</div>
              <div className="col-2">Texto 3</div>
            </div>
            <div className="row">
              <div className="col-1">texto 20</div>
              <div className="col-2">Texto 30</div>
            </div>
          </div>
          <div className="grafico-item">
          {/* <LineChart /> */}
          Texto de prueba 1
          </div>
        </li>
        <li key={Date.now()+Math.random().toString(16).substr(2, 8)} className="iotGrid-item">
          <div>
            <div className="row">
              <div className="col-1">texto 2</div>
              <div className="col-2">Texto 3</div>
            </div>
            <div className="row">
              <div className="col-1">texto 20</div>
              <div className="col-2">Texto 30</div>
            </div>
          </div>
          <div className="grafico-item">
          {/* <LineChart /> */}
          </div>
        </li>
        <li key={Date.now()+Math.random().toString(16).substr(2, 8)} className="iotGrid-item">
          <div>
            <div className="row">
              <div className="col-1">texto 2</div>
              <div className="col-2">Texto 3</div>
            </div>
            <div className="row">
              <div className="col-1">texto 20</div>
              <div className="col-2">Texto 30</div>
            </div>
          </div>
          <div className="grafico-item">
          {/* <LineChart /> */}
          </div>
        </li>
        <li key={Date.now()+Math.random().toString(16).substr(2, 8)} className="iotGrid-item">
          <div>
            <div className="row">
              <div className="col-1">texto 2</div>
              <div className="col-2">Texto 3</div>
            </div>
            <div className="row">
              <div className="col-1">texto 20</div>
              <div className="col-2">Texto 30</div>
            </div>
          </div>
          <div className="grafico-item">
          {/* <LineChart /> */}
          </div>
        </li>
        <li key={Date.now()+Math.random().toString(16).substr(2, 8)} className="iotGrid-item">Iot_1</li>
        <li key={Date.now()+Math.random().toString(16).substr(2, 8)} className="iotGrid-item">item 5</li>
        <li key={Date.now()+Math.random().toString(16).substr(2, 8)} className="iotGrid-item">item 6</li>
        <li key={Date.now()+Math.random().toString(16).substr(2, 8)} className="iotGrid-item">item 7</li>
        <li key={Date.now()+Math.random().toString(16).substr(2, 8)} className="iotGrid-item">item 8</li>
        <li key={Date.now()+Math.random().toString(16).substr(2, 8)} className="iotGrid-item">item 9</li>
      </ul>
    </div>
  );
};

export default Iot1;
